import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import BookingModal from "@/components/site/BookingModal";
import MobileCTA from "@/components/site/MobileCTA";
import ConsentBanner from "@/components/site/ConsentBanner";
import { trackPageview } from "@/lib/analytics";
import Home from "@/pages/Home";
import Resources from "@/pages/Resources";
import Article from "@/pages/Article";
import Dental from "@/pages/Dental";
import Insights from "@/pages/Insights";
import Legal from "@/pages/Legal";

const RouteEffects = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackPageview();
  }, [pathname]);
  return null;
};

function App() {
  return (
    <SiteProvider>
      <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <RouteEffects />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<Article />} />
          <Route path="/dental" element={<Dental />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/privacy" element={<Legal slug="privacy" />} />
          <Route path="/terms" element={<Legal slug="terms" />} />
          <Route path="/hipaa" element={<Legal slug="hipaa" />} />
        </Routes>
        <BookingModal />
        <MobileCTA />
        <ConsentBanner />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
      </MotionConfig>
    </SiteProvider>
  );
}

export default App;
